<template>
  <div class="module-wrapper hold-wrapper">

    <!-- 加载中 -->
    <div class="holdTitleV" @click="clickMore">
      <div>基金持仓</div>
      <img src="@/assets/right-arrow-gray.png"
         alt=""
         class="right-arrow"/></div>
    <!-- tab按钮组 -->
    <div class="mid-tag">
      <div class="tabs-mid-wrapper" v-if="!isMonetaryfund && !isFOFFund">
        <div v-for="(chart, index) in ['资产','行业','规模']"
          :key="index"
          @click="updateChart('typeIndex', index)"
          :class="[typeIndex === index ? 'stab' : 'tab']"
        >
          <div class="tabs--mid-item-text">
            {{ chart }}
          </div>
        </div>
      </div>
      <div class="tabs-mid-hb-wrapper" v-else>
        <div v-for="(chart, index) in ['资产','规模']"
          :key="index"
          @click="updateChart('typeIndex', index)"
          :class="[typeIndex === index ? 'stab' : 'tab']"
        >
          <div class="tabs--mid-item-text">
            {{ chart }}
          </div>
        </div>
      </div>
    </div>

    <!-- 图表组 -->
    <!-- <div class="chart-wrap-hold"></div> -->
    <div class="chart-hold-wrap-hold"
      :style="showguimo?'position:relative;opacity: 1;left: 0px;':''">
      <FundChartScale ref="FundChartScale" v-if="!dataEmpty" :showEmpty="showgmEmpty" />
      <div @click="clickMoregm" v-if="!dataEmpty" class="gmmorewrapper">
        <p class="gmmorewrappertt">更多规模信息</p>
      </div>
      <div v-if="dataEmpty" class="gmmorewrapper">
        <p class="gmmorewrempappertt">暂无数据</p>
      </div>
    </div>
    <div class="chart-hold-wrap-hold"
    :style="!showguimo?'position:relative;opacity: 1;;left: 0px;':''"
    >
      <div v-for="(chart, index) in config.chartList"
        :key="index"
        :class="['chart-item', typeIndex==index ? 'chart-item-avtive' : '']"
      >
        <!-- 加载中 -->
        <div v-if="isLoading" class="module-loading">信息加载中...</div>

        <div class="canvas-wrap">
          <div class="canvas-box">
            <canvas class="chart-canvas" :id="chart.id" />
            <div class="chart-par-info">
              <div class="par-info-title">{{ assetNum ? `${assetNum}亿元` : '--' }}</div>
              <div class="par-info-subtitle">净资产</div>
              <div class="par-info-date">
                {{ industryDataUpdateTime || assetDataUpdateTime || '--' }}
              </div>
            </div>
          </div>
        </div>

        <div class="no-circle-data" v-if="isNoData">暂无{{ chart.name }}分布数据</div>

        <!-- 图例 -->
        <div class="legend-wrap" v-else-if="chart.name === '资产' && holdAssetsLegendData">
          <div
            v-for="(d, index) in
            holdAssetsLegendData.slice(0, isShowMoreAsset || typeName!=='hb'?100:3)"
            class="hold-legend-item"
            :key="index"
          >
            <div class="item-dotted-box">
              <span class="item-dotted"
                :style="{
                  'background-color': config.type[typeName].assetColor[d.name]
                }"
              ></span>
            </div>
            <span class="item-name">{{ d.name }}</span>
            <span class="item-percend">{{ d.percent.toFixed(2) }}%</span>
          </div>
          <div v-if="typeName==='hb' && !isShowMoreAsset && holdAssetsLegendData.length > 3"
            class="more-asset"
            @click="showMoreAsset"
          >
            <span class="tips-text">更多资产分布</span>
          </div>
          <div v-if="isHoldAssetsMoreThen100"
            class="more-then-100-tips"
            @click="showMoreThen100Tips"
          >
            <span class="tips-text">为什么比例超过100%?</span>
          </div>
        </div>

        <div class="legend-wrap" v-else-if="chart.name === '行业' && holdIndustryLegendData">
          <div v-for="(d, index) in holdIndustryLegendData"
            class="hold-legend-item-wrap"
            :key="index"
          >
            <div v-if="isShowMoreIndustry || (!isShowMoreIndustry && index<3)"
              class="hold-legend-item"
            >
              <div class="item-dotted-box">
                <span class="item-dotted"
                  :style="{ 'background-color': config.colors[index] }"
                ></span>
              </div>
              <span class="item-name">{{ d.name }}</span>
              <span class="item-percend">{{ d.percent.toFixed(2) }}%</span>
            </div>
          </div>
          <div v-if="!isShowMoreIndustry && holdIndustryLegendData.length > 4"
            class="more-industry"
            @click="showMoreIndustry"
          >
            <span class="tips-text">更多行业分布</span>
          </div>
        </div>
      </div>
    </div>
  <div class="hold-new-tip-data" v-if="showHoldTip && !showguimo">
          {{gettip()}}
        </div>
  </div>
</template>

<script>
import F2 from '@antv/f2';
import FundChartScale from '@/components/FundChart/scale.vue';
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import { numeral } from '@fund/basic-lib';
import NativeMsg from '@/base/NativeMsg';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import { hold as config } from './config';
// import Model from './model';
import drawHoldAssets from './draw/hold_assets';
import drawHoldIndustry from './draw/hold_industry';

export default {

  props: ['showEmpty'],

  name: 'FundChartHold',

  components: {
    FundChartScale,
  },

  async mounted() {
    const info = await this.$getUserInfo();
    const {
      uid, deviceid, ctoken, utoken,
    } = info;
    this.publicParams = {
      CustomerNo: uid,
      UserId: uid,
      Uid: uid,
      CToken: ctoken,
      UToken: utoken,
      MobileKey: deviceid,

      deviceid: '5C1164BA-3D4A-4953-A488-00E47222D4BB' || deviceid,
      plat: 'Iphone',
      AppType: 'Iphone',
      product: 'EFund',
      version: '6.2.5',
      Serverversion: '6.2.5',
      appversion: '6.2.5',
    };
  },

  data() {
    return {

      // render回调执行后
      rendered: false,

      // 是否正在加载
      isLoading: true,

      // 是否无数据
      isNoData: false,

      // 数据类型索引
      typeIndex: -1,

      // 接口公共参数
      publicParams: {},

      // 资产图表数据
      holdAssetsLegendData: [],

      // 行业图表数据
      holdIndustryLegendData: [],

      // 资产原数据更新日期
      assetDataUpdateTime: null,

      // 行业原数据更新日期
      industryDataUpdateTime: null,

      // 是否展示更多行业分布
      isShowMoreIndustry: false,

      // 是否展示更多资产分布
      isShowMoreAsset: false,

      // 净资产数额
      assetNum: '',

      // 资产比例是否超过100%
      isHoldAssetsMoreThen100: false,

      // 是否是EFT重仓基金
      isEFT: false,

      // 是否是FOF基金
      isFOFFund: false,

      // 是否是货币基金 或 净值货币基金
      isMonetaryfund: false,

      // 图表配置
      config: {},

      // 资产数据
      FundMNInvestMoneyManagementCache: null,

      // 行业数据
      FundMNSectorAllocationCache: null,
      // 显示非报告期提示
      showHoldTip: true,
      FCODE: '',
      baseInfo: {},
      fundType: {},
      showguimo: false,
      holddate: '--',
      firstLoadClick: false,
      // 规模空
      dataEmpty: false,
    };
  },
  created() {
    NativeMsg.reg('ShowHoldViewShow', () => {
      this.gotoHoldViewShow();
    });
  },
  methods: {
    gotoHoldViewShow() {
      if (!this.firstLoadClick) {
        this.firstLoadClick = true;
        this.reportMonitor({
          eventName: 'pz.xx.assets',
        });
      }
    },
    showgmEmpty() {
      this.dataEmpty = true;
    },
    // 基金基本信息加载失败
    mainQueryError() {
      this.$props.showEmpty();
    },

    // eslint-disable-next-line no-unused-vars
    async render(isCache) {
      const refs = this.$refs;
      refs.FundChartScale.render();

      this.FCODE = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      this.baseInfo = StoreManger.getFundJJXQ();
      if (!isCache && !this.baseInfo) {
        this.$props.showEmpty();
        return;
      }

      const {
        FEATURE, FUNDTYPE, BFUNDTYPE,
      } = this.baseInfo;
      this.config = config;

      // 货币基金 或 净值货币基金 或 FOF
      this.isMonetaryfund = FundTypeSearch.isMonetaryfund(this.fundType)
        || (/^205$/.test(FUNDTYPE) && /^004|005$/.test(BFUNDTYPE));
      // 净值型货币理财
      // if (fundType === '205') {
      //   if (bFundType === '004') {
      //     this.tabList = ['阶段涨幅', '历史净值'];
      //   } else if (bFundType === '005') {
      //     this.tabList = ['阶段涨幅', '历史净值'];
      //   }
      // }

      // FOF基金
      this.isFOFFund = FundTypeSearch.isFOFFund(this.fundType);

      // 货币基金 或 ETF重仓基金 或 普通基金
      this.typeName = (this.isMonetaryfund && 'hb')
      || (/031/.test(FEATURE) && 'etf')
      || (this.isFOFFund && 'fof')
      || 'normal';

      this.rendered = true;
      config.chartList[0].f2 = null;
      config.chartList[1].f2 = null;

      // 请求资产接口
      if (this.isMonetaryfund && !this.isFOFFund) {
        const rowData = StoreManger.getFundHBCC();
        this.FundMNInvestMoneyManagementCache = {
          Datas: [rowData.Datas.FundMMAsset],
          Expansion: rowData.Expansion,
        };
        this.holddate = rowData.Expansion;
      } else {
        const basedata = StoreManger.getFundJJCC();
        if (basedata) {
          const Asset = basedata.AssetAllocation;
          const holdd = StoreManger.getFundJJCCExpansion();
          this.holddate = StoreManger.getFundJJCCExpansion();
          if (Asset && holdd) {
            const Assethold = Asset[holdd];
            if (Assethold) {
              if (Assethold.length > 0) {
                const assD = Assethold[0];
                this.FundMNInvestMoneyManagementCache = {
                  Datas: [assD],
                  Expansion: holdd,
                };
              } else {
                this.FundMNInvestMoneyManagementCache = {
                  Datas: [],
                  Expansion: holdd,
                };
              }
            } else {
              this.FundMNInvestMoneyManagementCache = {
                Datas: [],
                Expansion: holdd,
              };
            }
          } else {
            this.FundMNInvestMoneyManagementCache = {
              Datas: [],
              Expansion: '',
            };
          }
        } else {
          this.FundMNInvestMoneyManagementCache = {
            Datas: [],
            Expansion: '',
          };
        }
      }

      try {
        if (this.FundMNInvestMoneyManagementCache.Datas[0]
        && this.FundMNInvestMoneyManagementCache.Datas[0].JZC) {
          window.holdAllMoney = this.FundMNInvestMoneyManagementCache.Datas[0].JZC;
        }
      } catch (err) {
        console.error(err);
      }

      // 行业数据
      const basedata = StoreManger.getFundJJCC();
      if (basedata) {
        const Asset = basedata.SectorAllocation;
        const holdd = StoreManger.getFundJJCCExpansion();
        if (Asset && holdd) {
          const Assethold = Asset[holdd];
          if (Assethold) {
            this.FundMNSectorAllocationCache = {
              Datas: Assethold,
              Expansion: holdd,
            };
          } else {
            this.FundMNSectorAllocationCache = {
              Datas: [],
              Expansion: holdd,
            };
          }
        }
      } else {
        this.FundMNSectorAllocationCache = {
          Datas: [],
          Expansion: '',
        };
      }
      const manageCache = this.FundMNInvestMoneyManagementCache;
      const allocateCache = this.FundMNSectorAllocationCache;
      if (
        (!manageCache?.Datas?.length || !manageCache?.Datas[0])
        && (!allocateCache?.Datas?.length || !allocateCache?.Datas[0])
      ) {
        this.$props.showEmpty();
      } else {
        setTimeout(() => this.updateChart('typeIndex', 0), 300);
      }
    },
    // 更新图表
    async updateChart(key, value) {
      if (!this.rendered) return;
      // if (this[key] === value) return;
      // eslint-disable-next-line no-unused-expressions
      key && (this[key] = value);

      if (!this.isMonetaryfund && !this.isFOFFund) {
        if (value === 2) {
          this.showguimo = true;
          const refs = this.$refs;
          refs.FundChartScale.render();
          if (this.firstLoadClick) {
            this.reportMonitor({
              eventName: 'pz.xx.gm.click',
            });
          }
          return;
        }
      } else if (value === 1) {
        this.showguimo = true;
        const refs = this.$refs;
        refs.FundChartScale.render();
        if (this.firstLoadClick) {
          this.reportMonitor({
            eventName: 'pz.xx.gm.click',
          });
        }
        return;
      }
      const {
        typeIndex,
      } = this;
      this.showguimo = false;
      const chart = config.chartList[typeIndex];
      const eventName = `pz.xx.${chart.track}`;
      if (this.firstLoadClick) {
        this.reportMonitor({
          eventName,
        });
      }
      const exist = !!chart.f2;
      // 创建图表实例
      if (!chart.f2) {
        // #if EXECUTION_ENV === 'fund'
        if (window.innerWidth < 200) {
          // eslint-disable-next-line no-undef
          const systemInfo = fund.getSystemInfoSync();
          window.innerWidth = systemInfo.windowWidth / systemInfo.pixelRatio;
        }
        // #endif

        chart.f2 = new F2.Chart({
          id: chart.id,
          pixelRatio: window.devicePixelRatio,
          // width: window.innerWidth * 0.3733,
          height: 150,
          width: window.innerWidth * 0.36,
          padding: [0, 0, 0, 0],
        });
      }

      this.isNoData = false;

      // eslint-disable-next-line default-case
      switch (chart.name) {
        case '资产':
          try {
            const row = this.FundMNInvestMoneyManagementCache;
            this.isNoData = !row?.Datas?.length;
            this.assetDataUpdateTime = this.FundMNInvestMoneyManagementCache.Expansion.replace('--', '');
            // 格式化数据
            const { data, all } = drawHoldAssets.formatData(row, this.typeName);
            this.holdAssetsLegendData = data;
            this.isHoldAssetsMoreThen100 = all > 100;
            this.assetNum = row.Datas.length && (row.Datas[0].JZC - 0).toFixed(2);
            // 创建图表
            // eslint-disable-next-line no-unused-expressions
            !exist && drawHoldAssets.drawChart(data, chart.f2, this.typeName);
            // 刷新图表
            // eslint-disable-next-line no-unused-expressions
            exist && chart.f2.changeData(data);
          } catch (err) { console.error(err); }
          break;

        case '行业':
          try {
            // 加载数据
            const row = this.FundMNSectorAllocationCache;
            this.industryDataUpdateTime = this.FundMNInvestMoneyManagementCache.Expansion.replace('--', '');
            this.isNoData = !row?.Datas?.length;
            // 格式化数据
            const data = drawHoldIndustry.formatData(row);
            this.holdIndustryLegendData = data;
            // 创建图表
            // eslint-disable-next-line no-unused-expressions
            !exist && drawHoldIndustry.drawChart(data, chart.f2, this.changeSlideState);
            // 刷新图表
            // eslint-disable-next-line no-unused-expressions
            exist && chart.f2.changeData(data);
          } catch (err) { console.error(err); }
          break;
      }

      this.isLoading = false;
    },

    // 切换提示显示状态
    changeSlideState(bool) {
      this.isSliding = bool;
    },

    // 资产饼图总量超过100时提示
    showMoreThen100Tips() {
      this.$feedback.showModal({
        title: '温馨提示',
        content: '如果出现各资产总和占净值比例超过100%的现象，一般是由于基金在运作过程中存在负债，如存在应付账款或债券质押杠杆交易等情况。',
        confirmText: '知道了',
        showCancel: false,
        confirmColor: '#2f7eff',
        success: () => {},
      });
      this.reportMonitor({
        eventName: 'pz.jjcc.blsm.click',
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    clickMoregm() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '2',
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.gmfe',
      });
    },
    // 显示更多行业
    showMoreIndustry() {
      this.isShowMoreIndustry = true;
    },

    // 显示更多资产分布
    showMoreAsset() {
      this.isShowMoreAsset = true;
    },
    gettip() {
      const basedata = StoreManger.getFundJJCC();
      if (!basedata) {
        this.showHoldTip = false;
        return '';
      }
      const holddate = StoreManger.getFundJJCCExpansion();
      const Asset = basedata.AssetAllocation;
      if (!holddate || !Asset) {
        this.showHoldTip = false;
        return '';
      }
      let tip = '';
      let lastdate = holddate;
      Object.keys(Asset)
        .forEach((key) => {
          if (key > lastdate) {
            lastdate = key;
            const newAss = Asset[key];
            if (newAss.length > 0) {
              const assD = newAss[0];
              const time = formatDate(new Date(key), 'M月dd日');
              tip = `${time}披露最新净资产${numeral(assD.JZC).format('0.0000')}亿元，未披露持仓明细。`;
            }
          }
          if (key < holddate) {
            const newAss = Asset[key];
            if (newAss.length > 0) {
              const assD = newAss[0];
              const ftime = formatDate(new Date(holddate), 'M月dd日');
              const time = formatDate(new Date(key), 'yyyy年MM月dd日');
              tip = `${ftime}未披露净资产，${time}披露净资产${numeral(assD.JZC).format('0.0000')}亿元。`;
            }
          }
        });
      if (tip.length > 0) {
        this.showHoldTip = true;
      }
      return tip;
    },

  },
};
</script>

<style scoped lang="less">
  @import './style.less';
</style>
